import React, {useRef} from "react";
import "./style.css";
import { useEffect, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import MetrcAccount from "../../../components/forms/MetrcAccount.js";
import { Container, Grid2 as Grid, Tab, Tabs } from "@mui/material";
import { fetchMetrcAccounts} from "../../../redux/models/integrations/Action.js";
import { isNullOrUndefinedOrEmpty } from "../../../utils.js";
import { Syncs } from "../../../components/forms/Syncs.js";
import Loading from "../../../components/elements/Loading.js";
import { isEmpty } from "weed-js";
import {
    FACILITIES,
    BACKFILLS,
    ROUTES_INTEGRATIONS_METRC_DETAIL_BACKFILLS,
    AUTHENTICATION,
    ROUTES_INTEGRATIONS_METRC_DETAIL_AUTHENTICATION,
    ROUTES_INTEGRATIONS_METRC_DETAIL_FACILITIES
} from "../../../utils/Constants.js";
import MetrcFacilities from "./Facilities";


const Detail = ({tab , selectedOrganization, subscriptions, subscriptionItems, subscriptionProducts}) => {
    const params = useParams();
    const dispatch = useDispatch();
    const metrcAccountId = parseInt(params.id);
    const [searchParams, setSearchParams] = useSearchParams();
    const navigate = useNavigate();
    const previousOrganization = useRef(null);
    const [metrcAccounts, setMetrcAccounts] = useState([]);
    const [isLoading, setLoading] = useState(false);

    const loggedInUser = useSelector(state => state.userReducer.loggedInUser.user);

    const TabPanel = ({ children, index }) => {
        if (index === selectedTab) {
            return <>{children}</>;
        }
        return "";
    };

    const accountBelongsToSelectedOrganization = () => {
        if (isEmpty(metrcAccounts)) {
            return false;
        }
        const account = metrcAccounts.find(ma => parseInt(ma.id) === metrcAccountId);
        if (isEmpty(account)) {
            return false;
        }
        return account.organization_id === selectedOrganization.id;
    };

    useEffect(() => {
        const abortController = new AbortController();
        setLoading(true);
        dispatch(fetchMetrcAccounts({}, abortController)).then((fetchedMetrcAccounts) => {
            setLoading(false);
            setMetrcAccounts(fetchedMetrcAccounts);
        }).catch(err => {
            setLoading(false);
        });
        return () => {
            abortController.abort();
        };
    }, [loggedInUser.id]);

    const tabs = {
        null: 1,
        undefined: 1,
        [AUTHENTICATION]: 1,
        [BACKFILLS]: 2,
        [FACILITIES]: 3,
    };

    const whichTab = searchParams.get("tab") || tab;
    const metrcAccount = metrcAccounts.find(ma => parseInt(ma.id) === metrcAccountId);
    const [selectedTab, setSelectedTab] = useState(tabs[whichTab]);
    const selectTab = (event, newValue) => {
        setSelectedTab(newValue);
        if (newValue === tabs[BACKFILLS]) {
            navigate(ROUTES_INTEGRATIONS_METRC_DETAIL_BACKFILLS.replace(":id", metrcAccountId));
        } else if (newValue === tabs[AUTHENTICATION]) {
            navigate(ROUTES_INTEGRATIONS_METRC_DETAIL_AUTHENTICATION.replace(":id", metrcAccountId));
        } else if (newValue === tabs[FACILITIES]) {
            navigate(ROUTES_INTEGRATIONS_METRC_DETAIL_FACILITIES.replace(":id", metrcAccountId));
        }
    };

    if (isNullOrUndefinedOrEmpty(metrcAccount) || isLoading) {
        return <Loading />;
    }

    return <Container className="metrc-account-detail workspace">
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <h1>Metrc Account Details</h1>
                <h2>View/Edit</h2>
                <p>Learn about managing usage and quotas <a href={"https://www.youtube.com/watch?v=4oDkrzCtm4Q"}>here</a></p>
            </Grid>
        </Grid>
        <Tabs value={selectedTab} onChange={selectTab}>
            <Tab label="Authentication" value={1} tabIndex={1} />
            <Tab label="Facilities" value={3} tabIndex={3} />
            <Tab label="Sync Status" value={2} tabIndex={2} />
        </Tabs>
        <TabPanel index={1}>
            <MetrcAccount
                enableCreate={false}
                enableDelete={accountBelongsToSelectedOrganization()}
                enableEdit={accountBelongsToSelectedOrganization()}
                {...metrcAccount}
            />
        </TabPanel>
        <TabPanel index={2} onClick={() => navigate(ROUTES_INTEGRATIONS_METRC_DETAIL_BACKFILLS.replace(":id", metrcAccountId))} >
            <Syncs
                selectedOrganization={selectedOrganization}
                integrationAccountId={metrcAccountId}
                loggedInUser={loggedInUser}
                integrationNamespace={"metrc"}
            />
        </TabPanel>
        <TabPanel index={3} onClick={() => navigate(ROUTES_INTEGRATIONS_METRC_DETAIL_FACILITIES.replace(":id", metrcAccountId))} >
            <MetrcFacilities
                integrationAccount={metrcAccounts.find(m => m.id === metrcAccountId)}
                loggedInUser={loggedInUser}
                integrationNamespace={"metrc"}
            />
        </TabPanel>
    </Container>;
};


export default Detail;